import { AlmeColorProp } from "../../models/AlmeColorMapping";
import dialogConfig, { AlmeDialogConfig } from "../AlmeDialog/AlmeDialogConfig";

interface TimeoutWarningConfig extends AlmeDialogConfig {
    isEnabled: boolean;
    displayDuration: number;
    styles: {
        backgroundColor: AlmeColorProp;
    };
}

export interface AlmeTimeoutWarningConfig {
    timeout: TimeoutWarningConfig;
}

/**
 * This is the baseline timeout warning config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeTimeoutWarningConfig = {
    timeout: {
        ...dialogConfig,
        isEnabled: true,
        displayDuration: 6000,
        styles: {
            backgroundColor: 'paper',
        },
    },
};

export default defaultConfig;